export function fetchTitle(node) {
  let title = '';
  if (node.textContent) {
    title = node.textContent;
  } else if (node.querySelector('slot')) {
    // fetch text content from any nested structure
    let extractedText = '';
    const slotStructure = node.querySelector('slot').assignedNodes();
    Array.prototype.forEach.call(slotStructure, el => {
      if (el.textContent.replaceAll(' ', '') !== '') {
        extractedText += el.textContent;
      }
    });
    title = extractedText;
  }
  return title;
}
